import { isRoleWorkField } from '@rolebase/shared/model/role'
import { RoleWriteScope } from './contexts/RoleWriteScopeContext'

export interface RoleFieldWrite {
  editable: boolean
  // The meeting a save is made from, to send to the server (REU04-D14).
  meetingId: string | undefined
}

// Whether one field of a role is open, and from which meeting it is written.
//
// Both answers come from here so they cannot disagree (#170, 04/10/2026): the
// screen opened a meeting's work fields, but the save left without the meeting
// id — useUpdateRole read the meeting context at the org level, above the
// meeting step — so the server refused every write on a role the writer did not
// hold, in silence.
export function getRoleFieldWrite({
  field,
  canEditRole,
  canEditRoleWorkFields,
  writeScope,
}: {
  field: string
  canEditRole: boolean
  canEditRoleWorkFields: boolean
  writeScope?: RoleWriteScope
}): RoleFieldWrite {
  if (!isRoleWorkField(field)) {
    return { editable: canEditRole, meetingId: undefined }
  }
  // A meeting in progress opens the work fields to anyone in the room, on the
  // roles it shows (REU04-D12). The server re-checks everything it implies.
  const meetingId =
    writeScope?.canWrite && writeScope.meetingId
      ? writeScope.meetingId
      : undefined
  return { editable: canEditRoleWorkFields || !!meetingId, meetingId }
}
